import { styled } from "@mui/material/styles";
import { Suspense, useEffect } from "react";
import { Outlet } from "react-router-dom";

import { useIsMediaQuery } from "@/shared/hooks/useIsMediaQuery";
import SideNav from "@/shared/components/ui/SideNav/SideNav";
import GlobalProgressBar from "@/shared/components/ui/GlobalProgressBar/GlobalProgressBar";
import MaintenancePage from "@/shared/components/ui/MaintenancePage/MaintenancePage";
import TopNav from "@/shared/components/ui/TopNav/TopNav";
import { useSystemParamsStore } from "@/store/erp/administration/system-params.store";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import { useUiStore } from "@/store/ui/ui.store";
import useSocketBitacoraStore from "@/store/erp/socket/useSocketBitacora.store";
import { useAuthStore } from "@/store/auth";
import LoaderComponent from "@/shared/components/ui/LoaderComponent";
import MfaSetupGate from "./components/MfaSetupGate";
import TicketSoporteDatos from "@/shared/components/erp/ticketSoporte/FiltrosTicketSoporteDatos";
import { useModulesAutoSync } from "@/shared/actions/erp/tickets-soporte-cliente";

const SIDE_NAV_WIDTH = 280;

const LayoutRoot = styled("div", {
  shouldForwardProp: (prop) => prop !== "open",
})<{ open?: boolean }>(({ theme, open }) => {
  return {
    display: "flex",
    flex: "1 1 auto",
    maxWidth: "100%",
    [theme.breakpoints.up("lg")]: {
      paddingLeft: open ? 0 : SIDE_NAV_WIDTH,
    },
    transition: "width .5s ease",
  };
});

const LayoutContainer = styled("div")(() => {
  const isMobile = useIsMediaQuery("sm");

  return {
    // display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    width: "100%",
    //margin: '24px',
    padding: isMobile ? "0px 24px" : "24px",
  };
});

export interface ErpLayoutInterface { }

const ErpLayout: React.FC<ErpLayoutInterface> = () => {
  const isOpen = useUiStore((s) => s.openNav);
  const setOpenNav = useUiStore((s) => s.setOpenNav);
  const username = useAuthStore(s=>s.user?.username)
  /* const handleKeyDown = (event: React.KeyboardEvent) => {
    // block ctrl key
    if (event.ctrlKey) {
      event.preventDefault();
    }
  };

  const handleCopyPaste = (event: React.ClipboardEvent) => {
    // block copy paste
    event.preventDefault();
  };

  const handleContextMenu = (event: React.MouseEvent) => {
    // block right click
    event.preventDefault();
  }; */

  // const navigate = useNavigate();

  /* const getSystemParams = useSystemParamsStore((s) => s.getSystemParams);
  const mantenimiento = useSystemParamsStore((s) => s.mantenimiento); */
  const getSystemParams = useSystemParamsStore((s) => s.getSystemParams);
  const mantenimiento = useSystemParamsStore((s) => s.mantenimiento);

  const onInformacionSistema = useSystemParamsStore((s) => s.onInformacionSistema);
  ///* socket

  const onConnect = useDiccionarioMotivo((s) => s.onConnect);
  const onAlertaBitacora = useDiccionarioMotivo((s) => s.onAlertaBitacora);
  const onErrorBitacora = useDiccionarioMotivo((s) => s.onErrorBitacora);
  const onReconnect = useDiccionarioMotivo((s) => s.onReconnect);
  const onComentariosMotivos = useDiccionarioMotivo((s) => s.onComentariosMotivos);
  const onNuevoComentario = useDiccionarioMotivo((s) => s.onNuevoComentario);
  const socket = useDiccionarioMotivo().socket;
  const socketOff = useDiccionarioMotivo().socketOff;

  const isLgScreen = useIsMediaQuery("lg");

  const {
    connect
  } = useSocketBitacoraStore()

  // Sincronizar módulos del sistema al volver a enfocar la ventana
  useModulesAutoSync();

  useEffect(() => {
    connect(username!)
  }, [])

  useEffect(() => {
    if (isLgScreen) {
      setOpenNav(false);
    }
  }, [isLgScreen]);

  useEffect(() => {
    onConnect();
  }, []);

  useEffect(() => {
    //if (!socket) return;

    onAlertaBitacora();
    onErrorBitacora();
    onReconnect();
    onComentariosMotivos() // escuchar para obtener todos los comentarios
    onNuevoComentario() // escuchar nuevos comentarios
    getSystemParams({
      page_size: 1000
    });
    onInformacionSistema();

    return () => {
      socketOff();
    };
  }, [socket]);

  if (mantenimiento?.mantenimiento)
    return <MaintenancePage />;

  return (
    
    <div
      /* onKeyDown={handleKeyDown}
      onCopy={handleCopyPaste}
      onPaste={handleCopyPaste}
      onContextMenu={handleContextMenu}  */
      >
        <TopNav />
        <SideNav />
        <GlobalProgressBar />

        <LayoutRoot open={isOpen}>
          <LayoutContainer>
            <MfaSetupGate />
            <Suspense fallback={<LoaderComponent />}>
              <Outlet />
            </Suspense>
          </LayoutContainer>
        </LayoutRoot>
        {/* modal de datos soporte */}
        <TicketSoporteDatos/>
      </div>
  );
};

export default ErpLayout;
